var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRewardFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M2.5 13.284L13.284 2.5l7.702.514.514 7.702L10.716 21.5 2.5 13.284zm13.053-6.166a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M13.284 2.5l.033-.499-.226-.015-.16.16.353.354zM2.5 13.284l-.354-.354-.353.354.353.353.354-.353zm18.486-10.27l.5-.034-.03-.436-.436-.03-.034.5zm.514 7.702l.354.354.16-.16-.015-.227-.499.033zM10.716 21.5l-.353.354.353.353.354-.353-.354-.354zM12.93 2.146L2.146 12.93l.708.707L13.637 2.854l-.707-.708zm8.09.369L13.317 2l-.066 1 7.702.513.067-.997zm.979 8.168l-.514-7.703-.997.067.513 7.702.998-.066zm-10.93 11.17L21.855 11.07l-.708-.707-10.783 10.783.707.708zm-8.923-8.216l8.217 8.217.707-.708-8.216-8.216-.708.707zm14.907-5.519a1 1 0 01-1-1h-1a2 2 0 002 2v-1zm1-1a1 1 0 01-1 1v1a2 2 0 002-2h-1zm-1-1a1 1 0 011 1h1a2 2 0 00-2-2v1zm-1 1a1 1 0 011-1v-1a2 2 0 00-2 2h1z"
  }));
}
export default SvgIconRewardFill;